<section class="nrc-trust">
  <div class="nrc-trust__inner">
    <div class="nrc-trust__item">
      <span class="nrc-trust__value">
        <span class="nrc-trust__number">4.8/5</span>
      </span>
      <img src="assets/images/trustpilot-black.png" alt="Trustpilot" class="nrc-trust__logo" width="120" height="30" loading="lazy" />
    </div>
    <div class="nrc-trust__divider" aria-hidden="true"></div>
    <div class="nrc-trust__item">
      <span class="nrc-trust__value nrc-trust__value--text">BBB Verified</span>
      <img src="assets/images/certified-by/bbb-logo.png" alt="BBB" class="nrc-trust__logo" width="80" height="40" loading="lazy" />
    </div>
    <div class="nrc-trust__divider" aria-hidden="true"></div>
    <div class="nrc-trust__item">
      <span class="nrc-trust__value nrc-trust__value--text">Mapping technology</span>
      <img src="assets/images/certified-by/google-maps.png" alt="Google Maps" class="nrc-trust__logo" width="120" height="40" loading="lazy" />
    </div>
  </div>
</section>
